'use client'

import { useEffect, useRef, useState } from 'react'

export const formatTime = (seconds: number) => {
  const m = Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0')
  const s = (seconds % 60).toString().padStart(2, '0')

  return `${m}:${s}`
}

export const useCountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState(0)

  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null)

  const startTimer = (seconds: number) => {
    if (timerRef.current) clearInterval(timerRef.current)

    setTimeLeft(seconds)

    timerRef.current = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timerRef.current!)
          timerRef.current = null

          return 0
        }

        return prev - 1
      })
    }, 1000)
  }

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
      }
    }
  }, [])

  return { timeLeft, startTimer }
}
